import appStore from 'store';
import api from './api';

// const store = {
//   namespaced: true,
const store = {
  namespaced: true,
  state: () => ({
    currentPair: '', // 初始值改为空字符串，等待组件初始化时获取默认值
    askWhitelist: [],
    bidWhitelist: [],
    pairs: [],
    editItem: null,
    hasExistingAskData: false, // 拆分存在状态标识
    hasExistingBidData: false
  }),
  mutations: {
    setCurrentPair(state, payload) { // 新增交易对设置方法
      state.currentPair = payload;
    },
    setHasExistingData(state, { type, value }) { // 修改：支持类型参数
      state[`hasExisting${type}Data`] = value;
    },
    setWhitelist(state, { type, payload }) { // 修改：支持类型参数
      state[`${type}Whitelist`] = payload;
    },
    setAllPair(state, { payload }) {
      state[`pairs`] = payload;
    },
    setEditItem(state, payload) {
      state.editItem = payload;
    }
  },
  actions: {
    async fetchWhitelist({ commit, state }, type) { // 获取当前pair
      const res = await api.getWhitelist(type, state.currentPair); // 传递pair参数
      const data = res.data; // 从响应对象中解构data
      const stateKey = `${type}Whitelist`;
      const flagKey = `hasExisting${type}Data`;
      if (data && data.length > 0) {
        const parsed = JSON.parse(data[0].confValue);
        commit('setWhitelist', { type, payload: parsed });
        commit('setHasExistingData', { type, value: true });
      } else {
        commit('setWhitelist', { type, payload: [] });
        commit('setHasExistingData', { type, value: false });
      }
    },

    fetchAllPair({commit, state}) {
      return api.getAllPair().then(res => { // 添加return返回promise链
        const data = res.data;
        if (res.code === 0) {
          commit('setAllPair', {payload: data});
          // 新增：当首次加载且获取到交易对数据时，设置第一个选项为默认值
          if (data.length > 0 && !state.currentPair) {
            commit('setCurrentPair', data[0]);
          }
        }
      })
    },

    updateList({ state, commit, dispatch }, { type, newList }) {
      const hasExisting = state[`hasExisting${type}Data`];
      const currentPair = state.currentPair;

      if (hasExisting) {
        api.updateWhitelist(type, newList, currentPair).then(res => {
          dispatch('fetchWhitelist', type);
        });
      } else {
        api.createWhitelist(type, newList, currentPair).then(res => {
          dispatch('fetchWhitelist', type);
        });
      }
      return true;
    },

    // 设置当前编辑项
    setEditItem({ commit }, item) {
      commit('setEditItem', item);
    }
  }
};

// 关键修改：修正模块注册方式（移除斜杠保持命名空间一致性）
appStore.registerModule('tradeWhitelist', store);
